import { IAugmentedJQuery, IDocumentService, IWindowService } from 'angular';
import { StateService } from 'angular-ui-router';
import {
    PopoverController,
    PopoverService,
} from '../../tn.popover/service.tn.popover';
import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import { LocalFavorites } from '../local-favorites.service/localFavorites';
import template from './remove-favorite.html';

export class RemoveFavoriteController extends PopoverController {
    //bindings
    favorite?: IFavoriteList;

    static $inject = [
        '$window',
        '$document',
        '$element',
        'localFavorites',
        '$state',
        '$tnPopover',
    ];
    constructor(
        protected $window: IWindowService,
        protected $document: IDocumentService,
        protected $element: IAugmentedJQuery,
        protected localFavorites: LocalFavorites,
        protected $state: StateService,
        protected $tnPopover: PopoverService
    ) {
        super($window, $document, $element.children().first());
        $tnPopover.popovers.push(this);
    }

    removeFavoriteList(favlist: IFavoriteList) {
        this.localFavorites.deleteFavoriteList(favlist.id);
        this.$state.go('home.account.favorites');
    }
}

export const RemoveFavoriteComponent = {
    bindings: {
        favorite: '<',
    },
    controller: RemoveFavoriteController,
    template,
};
